// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const assetExportApiAssetsAssetIdExportPdfGetParamsAudienceDefault = `external`;
export const AssetExportApiAssetsAssetIdExportPdfGetParams = zod.object({
  "audience": zod.enum(['external', 'internal']).default(assetExportApiAssetsAssetIdExportPdfGetParamsAudienceDefault)
})

export type AssetExportApiAssetsAssetIdExportPdfGetParams = zod.input<typeof AssetExportApiAssetsAssetIdExportPdfGetParams>;
export type AssetExportApiAssetsAssetIdExportPdfGetParamsOutput = zod.output<typeof AssetExportApiAssetsAssetIdExportPdfGetParams>;
